import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useConfigStore } from '@packages/stores';

import { Assets } from '@assets';
import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { TextWithMd } from '@elements/text/textWithMd';
import { ROUTE_PATHS, getCurrentPathname, router } from '@routes/router';
import { useTripStore } from '@store';
import { sendAnalyticsEvent } from '@utils';

export interface QuoteRetryModalProps {
  children?: React.ReactNode;
}

export const QuoteRetry: FC<QuoteRetryModalProps> = () => {
  const { t } = useTranslation();
  const assistanceNumberConfig =
    useConfigStore(state => state.regionSpecificConfig?.CUSTOMER_SERVICE_OVERSEAS_NUMBER) ??
    '+61 2 8907 5085';

  const syncTrip = useTripStore(state => state.syncTrip);

  useEffect(() => {
    sendAnalyticsEvent('Quote API Time Out Modal');
  }, []);

  return (
    <div className="flex flex-col gap-8 items-center max-w-md text-center">
      <Assets.FaceFrown />
      <Text variant="h3-28/sb">{t('errors.quoteRetry.title')}</Text>
      <Text variant="body-16/m">{t('errors.quoteRetry.description')}</Text>
      <TextWithMd variant="body-16/m">
        {t('errors.quoteRetry.descriptionTwo', {
          CUSTOMER_SERVICE_OVERSEAS_NUMBER: assistanceNumberConfig,
        })}
      </TextWithMd>

      <div className="flex my-2 gap-4 w-full md:w-1/2">
        <Button
          onClick={async () => {
            sendAnalyticsEvent('Quote API Error Modal Try Again');
            const trip = await syncTrip();
            const { myQuote } = ROUTE_PATHS();
            if (trip) {
              if (getCurrentPathname() !== myQuote) {
                // We should navigate to the quote page if we are not already there
                router.navigate(myQuote);
              }
            }
          }}
          className="w-full"
          variant="primary"
          title="Try again"
        />
      </div>
    </div>
  );
};
